import {LatencyInfo} from '../types/LatencyInfo';
import {isFiniteNumber} from '../utils/numberUtils';

/**
 * Collects latency measurements and aggregates them over the interval a sample covers.
 *
 * All values are in milliseconds.
 */
export class LatencyMeter {
  private measurementCount = 0;
  private avgLatency = 0;
  private targetLatency: number | undefined;

  /**
   * @param targetLatency the target the measurement was taken against. Only the one offered with
   * the first measurement after a {@link reset} is kept.
   */
  addMeasurement(latency: number, targetLatency: number): void {
    if (!isFiniteNumber(latency)) {
      return;
    }

    this.measurementCount++;
    this.avgLatency += (latency - this.avgLatency) / this.measurementCount;

    if (this.targetLatency === undefined) {
      this.targetLatency = targetLatency;
    }
  }

  /**
   * Replaces the target of the current interval, whether or not one was already captured.
   */
  overrideTargetLatency(targetLatency: number): void {
    this.targetLatency = targetLatency;
  }

  getInfo(): LatencyInfo | undefined {
    if (this.measurementCount === 0 || this.targetLatency === undefined) {
      return undefined;
    }

    return {
      avgLatency: Math.round(this.avgLatency),
      targetLatency: Math.round(this.targetLatency),
      avgLatencyDelta: Math.round(this.avgLatency - this.targetLatency),
    };
  }

  reset(): void {
    this.measurementCount = 0;
    this.avgLatency = 0;
    this.targetLatency = undefined;
  }
}
